import React from "react";

class NewsFeed extends React.PureComponent {
    componentWillMount() {
        this.props.onLoad();
    }

    componentDidUpdate() {
        this.props.onLoad();
    }

    render() {
        let {items, loading} = this.props;
        if (loading) {
            return <div>Loading</div>
        }
        if (!items || !items.length) {
            return <div>Nothing to show</div>
        }
        return <table className="zw-tbl news-feed-tbl">
            <tbody>
            {items.map(item =>

                <NewsFeedItem key={item.id} {...item}/>
            )}
            </tbody>
        </table>;
    }
}

const NewsFeedItem = ({title, link, publishedOnTime}) =>
    <tr>
        <td>
            {publishedOnTime}
        </td>
        <td>
            <a href={link} rel="noopener noreferrer" target="_blank">
                {title}
            </a>
        </td>
    </tr>;

export default NewsFeed;